module.exports = __webpack_public_path__ + "img/arrow.9c5a0402.svg";